const formValidator = (payload) => {
  let isValid = true;
  const obj = {
    type: 'error',
    message: '',
  };
  if (!payload.position) {
    obj.message = 'experience position is required!';
    isValid = false;
  }
  if (!payload.institution_name) {
    obj.message = 'experience authority is required!';
    isValid = false;
  }
  if (!payload.date_from) {
    obj.message = 'experience date from is required!';
    isValid = false;
  }
  if (isValid) {
    return 'valid';
  }
  return obj;
};

export default formValidator;
